import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { CARD, INPUT, PRIMARY_BTN } from "./adminStyles";

export const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    setError((await onLogin(username, password)) || "");
    setBusy(false);
  };
  const onKey = (e) => e.key === "Enter" && submit();

  return (
    <div className="min-h-screen bg-[#0a0e17] flex items-center justify-center">
      <Card className={`${CARD} p-8 w-full max-w-md`} data-testid="admin-login-card">
        <div className="flex items-center justify-center mb-6"><Lock className="h-12 w-12 text-ism-teal" /></div>
        <h2 className="text-2xl font-bold text-white text-center mb-6">Admin Panel</h2>
        <div className="space-y-4">
          <div>
            <Label className="text-gray-400">Username</Label>
            <Input type="text" value={username} onChange={(e) => setUsername(e.target.value)} onKeyDown={onKey} placeholder="Admin username" className={INPUT} data-testid="admin-username" />
          </div>
          <div>
            <Label className="text-gray-400">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={onKey} placeholder="Admin password" className={INPUT} data-testid="admin-password" />
          </div>
          {error && <p className="text-red-400 text-sm text-center" data-testid="admin-login-error">{error}</p>}
          <Button onClick={submit} disabled={busy} className={`w-full ${PRIMARY_BTN}`} data-testid="admin-login-btn">Login</Button>
        </div>
      </Card>
    </div>
  );
};
